import domWrap from "../utils/domWrap";

export default async takeover => { // 'take-over'
	domWrap(takeover).on('click', 'button.icon-close, comp-cover', function () {
		takeover.classList.add('fade-out');
		setTimeout(() => takeover.remove(), 300);
	});
};